/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import InfoCircleIcon from "assets/icons/info-circle.svg";
import CloseIcon from "assets/icons/menu-close.svg";
import { cn } from "tailwind-variants";

export default function PinningDisclaimer({ compact = false, onDismiss, ...restProps }: any) {
  return (
    <div
      {...restProps}
      className={cn(
        "mb-2 flex items-center gap-2 rounded-lg bg-purple-200 px-3 py-2",
        restProps.className
      )}
      data-testid="pinning-disclaimer"
    >
      <InfoCircleIcon
        className={cn("shrink-0 text-gray-900", compact ? "size-5" : "size-6")}
        data-testid="shrink-0"
      />
      <span className="m-0 flex-1 text-sm leading-relaxed text-gray-900">
        {" "}
        AI edits your design. If it can't, a free professional artist will.{" "}
      </span>
      <button
        className="shrink-0 cursor-pointer rounded border-none bg-transparent text-gray-700 hover:text-gray-900"
        type="button"
        aria-label="Dismiss disclaimer"
        data-testid="pinning-disclaimer-dismiss"
        onClick={() => {
          onDismiss();
        }}
      >
        <CloseIcon
          className={cn("text-gray-700 hover:text-gray-900", compact ? "size-5" : "size-6")}
          data-testid="text-gray-700"
        />
      </button>
    </div>
  );
}
